import {
  PRESET_KEYS,
  type PresetConfig,
  type PresetConfigKey,
} from './patterns.types';

export const PatternConfig = {
  MAX_PATTERNS: 30,
  PATTERN_HINT_MAX_LENGTH: 36,
  DEFAULT_OFFSET_CUSTOM_INTENSITY: 50,
  DEFAULT_ROTATION_CUSTOM_INTENSITY: 25,
  ROTATION_INTENSITY_MIN: -100,
  ROTATION_INTENSITY_MAX: 100,
  OFFSET_INTENSITY_MIN: 0,
  OFFSET_INTENSITY_MAX: 100,
  INTENSITY_SLIDER_STEP: 1,
  ROTATION_SLIDER_START_POINT: 0,
  ROTATION_PATTERN_MIN_DEGREES: -360,
  ROTATION_PATTERN_MAX_DEGREES: 360,
  OFFSET_PATTERN_MIN_PX: -100,
  OFFSET_PATTERN_MAX_PX: 100,
} as const;

export const PATTERN_RANGES = {
  rotation: {
    min: PatternConfig.ROTATION_PATTERN_MIN_DEGREES,
    max: PatternConfig.ROTATION_PATTERN_MAX_DEGREES,
  },
  offset: {
    min: PatternConfig.OFFSET_PATTERN_MIN_PX,
    max: PatternConfig.OFFSET_PATTERN_MAX_PX,
  },
} as const;

const createOption = <T extends string>(value: T, label: string) => ({
  value,
  label,
});

const createDivider = () => ({
  type: 'divider' as const,
});

export const getScopeOptions = (translate: (key: string) => string) => [
  createOption(
    'character',
    translate(
      'Inspector-TextEffects.Section-Design.RotateandOffset.Per.Character',
    ),
  ),
  createOption(
    'word',
    translate('Inspector-TextEffects.Section-Design.RotateandOffset.Per.Word'),
  ),
];

export const PRESET_CONFIGS: Record<PresetConfigKey, PresetConfig> = {
  'Fridge Magnet': {
    label: 'Fridge Magnet',
    translationKey:
      'Inspector-TextEffects.Section-Design.RotateandOffset.Pattern.FridgeMagnets',
    character: {
      rotation: '10, -5, -10',
      offset: '-5, 0, 25',
      rotationIntensity: 35,
      offsetIntensity: 35,
    },
    word: {
      rotation: '10, -5, -10',
      offset: '',
      rotationIntensity: 35,
      offsetIntensity: 100,
    },
  },
  Wave: {
    label: 'Wave',
    translationKey:
      'Inspector-TextEffects.Section-Design.RotateandOffset.Pattern.Wave',
    character: {
      rotation: '',
      offset: '-40, -10, 20, 50, 80, 50, 20, -10',
      rotationIntensity: 100,
      offsetIntensity: 35,
    },
    word: {
      rotation: '-30, 30',
      offset: '',
      rotationIntensity: 10,
      offsetIntensity: 100,
    },
  },
  Bounce: {
    label: 'Bounce',
    translationKey:
      'Inspector-TextEffects.Section-Design.RotateandOffset.Pattern.Bounce',
    character: {
      rotation: '',
      offset: '0, 30, -30, 0, 30',
      rotationIntensity: 100,
      offsetIntensity: 24,
    },
    word: {
      rotation: '',
      offset: '10, 50, -10, -50',
      rotationIntensity: 100,
      offsetIntensity: 50,
    },
  },
} as const;

export const getPresetOptions = (translate: (key: string) => string) => [
  ...PRESET_KEYS.map(key =>
    createOption(key, translate(PRESET_CONFIGS[key].translationKey)),
  ),
  createDivider(),
  createOption(
    'custom',
    translate(
      'Inspector-TextEffects.Section-Design.RotateandOffset.Pattern.Custom',
    ),
  ),
];
